<template>
  <div class="form-group" style="margin-top: 16px;">
    <label class="custom-label">Company *</label>

    <div class="alert">
      <el-select id="selectCompany" v-model="selectedCompany" @change="selectCompany" placeholder="Choose your company"
        popper-class="company-select__dropdown" v-bind:class="{ 'success-input': selectedCompany }"
        class="required-element" required>
        <el-option v-for="company in companies" :key="company.value" :label="company.label" :value="company.value">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>

export default {
  name: "FormCompanySelect",
  data() {
    return {
      companies: [{
        value: 'Tonti Laguna Group',
        label: 'Tonti Laguna Group',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Tonti_Laguna_Group.png'
      }, {
        value: 'Tonti Laguna Prime',
        label: 'Tonti Laguna Prime',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Tonti_Laguna_Prime.png'
      }, {
        value: 'Black Ring',
        label: 'Black Ring',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Tonti_Laguna_Group.png'
      }, {
        value: '42n',
        label: '42n',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/42n.png'
      }, {
        value: 'Asolytics',
        label: 'Asolytics',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Asolytics.png',
        link: 'https://asolytics.tools/'
      }, {
        value: 'Choice31',
        label: 'Choice31',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Tonti_Laguna_Group.png',
        link: 'https://choice31.com/'
      }, {
        value: 'select form',
        label: 'select form',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Tonti_Laguna_Group.png'
      }, {
        value: 'PDFLiner',
        label: 'PDFLiner',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/PDFLiner.png',
        link: 'https://pdfliner.com/'
      }, {
        value: 'LOCATION',
        label: 'LOCATION',
        logoUrl: 'https://signature.tontilaguna.com/img/logo/Tonti_Laguna_Group.png',
        link: 'https://www.locationstudio.com.ua/'
      }],
      selectedCompany: ''
    }
  },
  computed: {
    selectedCompanyObj() {
      return this.companies.find(company => company.value === this.selectedCompany) || {};
    }
  },
  methods: {
    selectCompany() {
      let companySelect = document.getElementById('selectCompany');

      if (this.selectedCompany) {
        companySelect.classList.add('success-input');
      } else {
        companySelect.remove('success-input');
      }
      this.$emit('selected-company', this.selectedCompanyObj);
    },
  },
}
</script>

<style lang="scss">
/* transition */
$base-transition: all .3s cubic-bezier(.2, .57, .36, .8);

.el-select {
  width: 100%;

  .el-input__inner {
    height: 48px;
    padding: 0 46px 0 16px;
    background: #ffffff;
    border: none;
    border-radius: 4px;
    box-shadow: 0 4px 12px 0 rgba(95, 136, 204, 0.16);
    transition: $base-transition;
  }

  .el-input {
    &.is-focus {
      .el-input__suffix {
        &::before {
          transform: rotate(180deg);
        }
      }
    }
  }

  .el-input__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 100%;

    &::before {
      content: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNyA1LjQ0NSAxMi40NDUgMCAxNCAxLjU1NWwtNyA3LTctN0wxLjU1NSAweiIgZmlsbD0iI0I1QjhCRSIgZmlsbC1ydWxlPSJub256ZXJvIi8+Cjwvc3ZnPgo=");
      display: inline-flex;
      align-items: center;
      width: 14px;
      height: 9px;
    }
  }

  .el-input__suffix-inner,
  .el-select__caret {
    display: none;
  }
}

.company-select__dropdown {
  &.el-popper {
    &[x-placement^=top] {
      margin-bottom: 8px;
    }

    &[x-placement^=bottom] {
      margin-top: 8px;
    }

    .popper__arrow {
      display: none;
    }
  }

  .el-select-dropdown__list {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 16px;

    li.el-select-dropdown__item {
      display: flex;
      width: 100%;
      height: unset;
      margin-bottom: 8px;
      padding: 0;
      line-height: 1;

      &:last-child {
        margin-bottom: 0;
      }

      span {
        font-size: 16px;
        line-height: 1.5;
        color: #242930;
        transition: $base-transition;
      }

      &.hover,
      &:hover {
        background: none !important;

        span {
          color: #1a85ff;
        }
      }

      &.selected {
        font-weight: normal;
        color: #1a85ff;
      }
    }
  }
}
</style>